export type FormComponent = {
  title: string
  editable: boolean
  type: FormComponentType
  required?: boolean
  options?: {
    id: string | number
    value: string | number
  }[]
  modifier?: (value: string) => string
  validateFieldsOnChange?: string[]
}

export enum FormComponentType {
  NameInput = "nameinput",
  Input = "input",
  Number = "number",
  Textarea = "textarea",
  Checkbox = "checkbox",
  Dropdown = "dropdown",
  Date = "date",
}
